module.exports = __webpack_public_path__ + "media/src/img/payment/image5-88301e49f9db111031ffc7c294cd5a18.png";